export default "__VITE_ASSET__BXZM4Cvx__"